export const DDEX_ROUTES = {
  ROOT: '/',

  DDEX_LIST: '/release/ddex',
} as const;
